import { h, render, Component } from 'preact';
import { classNames, formatNumber } from '../utils/utils';
import { PlanService } from '../plan-service.service';
class TxrPlanPanels extends Component {
    state = {
        tabNum: 0,
        plans: []
    }

    onHashChange = () => {
        if (window.location.hash === '#standard') {
            this.toggle(0);
        }
        if (window.location.hash === '#high-volume') {
            this.toggle(1);
        }
        if (window.location.hash === '#political') {
            this.toggle(2);
        }
    };
    componentDidMount() {
        const plans = new PlanService();
        this.setState({ plans: plans.getPlans() });
        window.addEventListener('hashchange', this.onHashChange);
        this.onHashChange();
    }
    componentWillUnmount() {
        window.removeEventListener('hashchange', this.onHashChange);
    }

    planSelect(item) {
        const selectEventData = {
            'event': 'plan_select', 
            'event_category': 'ecommerce', 
            'elementId': item.name, 
            'purchase_plan_type': item.name, 
            'total_purchase': 0,
            'purchased_features': [], 
        };
        gtag('event', 'plan_select', selectEventData);
        setTimeout(() => {
            location.href='/purchase?plan='+item.link;
        }, 500);
        
    }
    render() {
        return (
            <div class="txr-plan-panels">
                <a id="high-volume"></a>
                <div class="plan-panels__buttons">
                    <h4 class={'plan-panels__button' + (this.state.tabNum === 0 ? ' button-selected' : '')} onClick={() => this.toggle(0)}>Standard Plans<span class="txr-md-hidden">&nbsp;(4)</span></h4>
                    <h4 class={'plan-panels__button' + (this.state.tabNum === 1 ? ' button-selected' : '')} onClick={() => this.toggle(1)}>High Volume<span class="txr-md-hidden txr-ml5">Plans&nbsp;(3)</span></h4>
                    <h4 class={'plan-panels__button' + (this.state.tabNum === 2 ? ' button-selected' : '')} onClick={() => this.toggle(2)}>Political Texting</h4>
                </div>
                <div class="plan-panels__headers">
                    {this.state.tabNum === 0 && <h3 class="plan-panels__title txr-h">Plans for every business, even yours</h3>}
                    {this.state.tabNum === 1 && <h3 class="plan-panels__title txr-h">For larger brands to fuel growth</h3>}
                    {this.state.tabNum === 2 && <h3 class="plan-panels__title txr-h">Buy once, use anytime</h3>}
                    {/*this.state.tabNum === 0 && <div class="plan-panels__text txr-h">No contracts. 30-day money back guarantee on Basic and Starter plans. Free Support. Unlimited users, contacts, devices, contact groups, and group sizes. Note: 1 Dashboard = 1 Text Line</div>*/}
                    {this.state.tabNum === 0 && <div class="plan-panels__text txr-h">Free support and no contracts. <br/> Unlimited users, contacts, devices, contact groups, and group sizes.<br/> Note: 1 Dashboard = 1 Text Line<br/>
                            <a class="txr-button-link" href="/trial">
                                <button class="right-details__button txr-button txr-primary-button txr-width130" type="button">
                                    <span class="txr-button__content">TRY IT FREE<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                </button>
                            </a>
                        </div>}
                    {this.state.tabNum === 1 && <div class="plan-panels__text txr-h">Extend your reach and keep every employee on the same page. Plans come with every feature, and discounted rates for texts and dashboards.</div>}
                    {this.state.tabNum === 2 && 
                    <div class="plan-panels__text txr-h">No contracts. Peer to Peer Texting. Unlimited users and contacts. Free onboarding and support. Political Texting accounts are setup by a Text Request employee. All we need is your Campaign Verify token and your initial bucket of texts.
                        <div><a class="txr-angle__link" href="/product/peer-to-peer">Learn More  <i class="txr-angle__link-icon fal fa-angle-right"></i></a></div>
                    </div>
                    }
                    
                </div>
                {   this.state.tabNum !== 2 &&
                    <div class={'plan-panels__items' + (this.state.tabNum === 1 ? ' high' : ' standard')}>
                    {
                       this.state.plans.map(item => 
                        <div class={'plan-panels__item-container' + (item.discountPrice ? ' popular' : '') + (item.isHighVolume ? ' high' : ' standard')}>
                            <a href='/promotion-terms' target='__blank' class="plan-item__popular discount">20% OFF FIRST 3 MONTHS*</a>
                            <div class="plan-panels__item">
                                <div class="plan-item__header">{item.name}</div>
                                {item.discountPrice && <div class="plan-item__price">${formatNumber(item.discountPrice)}<span class="plan-item__price-orig">${formatNumber(item.newPrice)}</span></div>}
                                {!item.discountPrice && <div class="plan-item__price">${formatNumber(item.newPrice)}<span class="plan-item__price-range">/ mo</span></div>}
                                <div class="plan-item__price-hint">Billed monthly</div>
                                <div class="plan-item__line txr-mb20"></div>
                                <div class="plan-item__value">
                                    <h4 class="plan-item__value-val txr-h">{item.includedTexts}</h4>
                                    <div class="plan-item__value-text">Included texts</div>
                                </div>
                                <div class="plan-item__value">
                                    <h4 class="plan-item__value-val txr-h">{item.dashboards}</h4>
                                    <div class="plan-item__value-text">Dashboard{item.dashboards == 1 ? '' : 's'}</div>
                                </div>
                                <div class="plan-item__value">
                                    <h4 class="plan-item__value-val txr-h">{item.addTextsNew}</h4>
                                    <div class="plan-item__value-text">Additional texts</div>
                                </div>
                                <div class="plan-item__line yxr-mt10 txr-mb30"></div>
                                <a class="txr-button-link" onClick={() => this.planSelect(item)}>
                                    <button class="right-details__button txr-button txr-primary-button txr-width130" type="button">
                                        <span class="txr-button__content">SELECT<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                                    </button>
                                </a>
                                <div class="plan-item__included">{item.isHighVolume ? 'Included features:' : "What's included:"}</div>
                                {
                                    item.includedFeatures.map(feature => 
                                        <div class="plan-item__feature">
                                            <img class="plan-item__feature-img" src="/images/pricing/icn-check-mark.svg" alt="checkmark"></img>
                                            <div class="plan-item__feature">{feature}</div>
                                        </div>
                                    )
                                }
                                {
                                    item.isHighVolume &&
                                        <div class="plan-item__feature">
                                            <img class="plan-item__feature-img" src="/images/pricing/icn-plus.svg" alt="plus"></img>
                                            <div class="plan-item__feature">$5 Additional Dashboards</div>
                                        </div>
                                }
                                {
                                    item.isHighVolume &&
                                        <div class="plan-item__feature">
                                            <img class="plan-item__feature-img" src="/images/pricing/icn-check-mark.svg" alt="checkmark"></img>
                                            <div class="plan-item__feature">All Enterprise Features</div>
                                        </div>
                                }
 
                                
                            </div> 
                        </div>    
                      )
                    }
                    </div> 
                }
                {
                    this.state.tabNum === 2  &&
                    <div class='plan-panels__items political'>
                             <div class='political-box'>
                                 <div class="political-left">
                                    <div class="political-left__header">
                                        <div class="political-left__header-fee">$145</div>
                                        <div class="political-left__header-hint">One-time setup fee, per campaign</div>
                                    </div>
                                    <div class="political-left__title">Choose your initial commitment:</div>
                                    <div class="political-left__content">
                                        <div class="political-left__item">
                                            <div class="item-price">
                                                $1,000
                                            </div>
                                            <div class="item-price type2 txr-mt20">
                                                $0.02 per SMS
                                            </div>
                                            <div class="item-price type2 txr-mt5">
                                                $0.04 per MMS
                                            </div>
                                        </div>    
                                        <div class="political-left__item">
                                            <div class="item-price">
                                                $10,000
                                            </div>
                                            <div class="item-price type2 txr-mt20">
                                                $0.01 per SMS
                                            </div>
                                            <div class="item-price type2 txr-mt5">
                                                $0.03 per MMS
                                            </div>
                                        </div>                                            
                                    </div>
                                 </div>
                                 <div class="political-right">
                                        <div class="political-right__box-title">Text or call us to get started!</div>
                                        <div class="political-right__box-phone">423-218-0111</div>
                                 </div>
                             </div>
                     </div>
                }
                {
                this.state.tabNum !== 2 && <div class="plan-panels__hint-container">
                    <div class={'plan-panels__hint' + (this.state.tabNum == 1 ? ' high' : ' standard')}>
                        Prices in USD. Sales tax may apply.
                        { this.state.tabNum == 0 &&
                        <div>
                            *Use of promo code SUMMER20 entitles new customers to a 20% discount off Basic, Starter, and Corporate plans. <a target="_blank" href="/promotion-terms" class="txr-text__link">Terms apply.</a>
                        </div>
                        }                   
                    </div> 
                </div>     
                }
            </div>
        )
    }

    toggle = (value) => {
        this.setState({ tabNum: value });
    }
}

export default TxrPlanPanels;
